module.exports = __webpack_public_path__ + "img/pl_pl.4d119fa5.png";